import React from "react";
import {
    Row,
    Col,
    Form,
    Button,
  } from "antd";

const MultiInput: React.FC<any> = ({
    listName,
    cols,
    RenderFields,
    projects,
    addOtherLocation,
    onProjectChange,
    adminRoles,
  }) => {
    return (
      <Form.List name={listName}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row className="mt-3" key={key} style={{ width: "100%" }}>
                <Col span={20} className="pr-2" xs={24} sm={20}>
                  <Row>
                    {cols?.map((col, k) => (
                      <Col span={col.ColSize} className="pr-2" key={k}>
                        <RenderFields
                          data={col}
                          name={name}
                          restField={restField}
                          projects={projects}
                          addOtherLocation={addOtherLocation}
                          onProjectChange={onProjectChange}
                          adminRoles={adminRoles}
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>
                <Col span={4} xs={24} sm={4}>
                  <Form.Item>
                    <Button
                      className="beam-btn w-full more-btn"
                      onClick={() => {
                        remove(name);
                      }}
                    >
                      Remove
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            ))}
            <Row className="mt-3" style={{ width: "100%" }}>
              <Col span={24}>
                <Form.Item>
                  <Button
                    className="beam-btn w-full more-btn"
                    onClick={() => {
                      add();
                    }}
                  >
                    Add
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Form.List>
    );
  };

  export default MultiInput;